<button
  nz-button
  [nzLoading]="userIdleDetector.isWatching()"
  (click)="startIdleDetection()"
  size="small"
>
  {{ userIdleDetector.isWatching() ? "Idle Detection Started" : "Start Idle Detection" }}
</button>
